export default {
    namespaced: true,
    state: () => ({
      newOperationData : {}
    }),
    mutations: {
      setNewOperationData(state, data){
        state.newOperationData[data.idScheduledOperation] = data.data;
      }
    },
    actions: {
      setNewOperationData({commit}, payload){
        commit("setNewOperationData", payload)
      }
    },
    getters: {
      getNewOperationData: (state) => (idScheduledOperation) => {
        return state.newOperationData[idScheduledOperation];
      }
    }
  }